// extracted by mini-css-extract-plugin
export default {"auth__banner":"AuthBanner_auth__banner__5BlIW"};